(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rad-harvest-sale"] && !Shopify.designMode) return;
  try {
    
function radExpireHarvest(){document.querySelectorAll('[data-rad-harvest]').forEach(function(el){if(el.dataset.editor==='true')return;var end=Date.parse(el.dataset.end);if(Number.isFinite(end)&&Date.now()>=end)el.hidden=true;});}radExpireHarvest();setInterval(radExpireHarvest,60000);document.addEventListener('shopify:section:load',radExpireHarvest);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rad-smart-pairings"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rad-smart-pairings')) {
  customElements.define('rad-smart-pairings', class extends HTMLElement {
    async connectedCallback() {
      if (this.hidden || this.ready) return;
      this.ready = true;
      if (this.dataset.fallback === 'true' && !this.querySelector('[data-card]')) {
        try {
          const response = await fetch(this.dataset.url, {credentials:'same-origin'});
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('rad-smart-pairings .rad-pairings__content');
          if (!content) return;
          this.querySelector('.rad-pairings__content').replaceWith(content);
        } catch { return; }
      }
      this.cards = [...this.querySelectorAll('[data-card]')];
      if (!this.cards.length) { this.hidden = true; return; }
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency || 'USD'});
      try {
        const response = await fetch(this.root() + 'cart.js', {credentials:'same-origin'});
        if (!response.ok) throw new Error();
        const cart = await response.json();
        const inCart = new Set(cart.items.map(item => String(item.product_id)));
        this.cards.forEach(card => { if (inCart.has(card.dataset.product)) card.remove(); });
      } catch {}
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.cards.slice(3).forEach(card => card.remove());
      this.cards = this.cards.slice(0,3);
      if (!this.cards.length) {this.hidden=true;return;}
      this.querySelector('.rad-pairings__content').hidden = false;
      this.addEventListener('change', () => this.update());
      this.button.addEventListener('click', () => this.add());
      this.update();
      this.track('rad_pairings_view', {product_id:this.dataset.product,source:this.dataset.source});
    }
    root() { return this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/'; }
    track(event, data) {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(event,data);
    }
    update() {
      let total=0, count=0, valid=true;
      this.cards.forEach(card => {
        const select=card.querySelector('[data-variant]');
        const option=select.selectedOptions[0];
        const price=Number(option.dataset.price || 0);
        card.querySelector('[data-price]').textContent = option.value ? this.money.format(price/100) : card.dataset.starting;
        if (card.querySelector('[data-check]').checked) {count++;total+=price;if (!option.value) valid=false;}
      });
      this.querySelector('[data-total]').textContent=this.money.format(total/100);
      this.button.disabled=!count || !valid || this.busy;
      if (!this.busy) this.status.textContent=count && !valid ? this.messages.choose : '';
    }
    async add() {
      if (this.busy) return;
      const selected=this.cards.filter(card=>card.querySelector('[data-check]').checked);
      const items=selected.map(card=>({id:Number(card.querySelector('[data-variant]').value),quantity:1,properties:{_rad_pairing_source:this.dataset.source,_rad_pairing_parent:this.dataset.product}}));
      if (!items.length || items.some(item=>!item.id)) return;
      this.busy=true;this.button.disabled=true;this.button.textContent=this.messages.adding;this.status.textContent='';
      try {
        const response=await fetch(this.root()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if (!response.ok) throw new Error(typeof result.description==='string'?result.description:this.messages.error);
        this.track('rad_pairings_add',{product_id:this.dataset.product,source:this.dataset.source,variant_ids:items.map(item=>item.id)});
        window.location.assign(this.root()+'cart');
      } catch(error) {
        this.busy=false;this.button.textContent=this.messages.add;this.update();this.status.textContent=error.message || this.messages.error;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
